import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { encryptionShowFocusHost, encryptionHostLive, encryptionFocusHost } from "@/api/php/user";

import { cheackQuery, nativeToLogin, nativeToNewWeb, ToBack } from "@/uitls/native";
import { Toast } from "vant";
import { hostRankingList } from "@/api/php/home";
import { storeToRefs } from "pinia"
import { usePiniaState } from "@/store/userPinia";
import { uitlsToLiveRoom } from "@/uitls/uitls";
import { useI18n } from 'vue-i18n'

// const livetj = require(`@/assets/${process.env.VUE_APP_NAME}/home-match-rec.png`)

export default /*#__PURE__*/_defineComponent({
  name: 'Subscribe',
  setup(__props, { expose }) {
  expose();

const livezb = require(`@/assets/${process.env.VUE_APP_NAME}/live-gif.gif`)
const zbtype = require(`@/assets/${process.env.VUE_APP_NAME}/zbtype.png`)

const { t } = useI18n()
const piniaStore = usePiniaState();
const { isYk } = storeToRefs(piniaStore);
const router = useRouter();
let data = ref([]);
const route = useRoute();

onMounted(() => {
  cheackQuery(route);
  getdata();
});

const hotzb = ref([])
//获取明星主播的数据
const getHostRankingList = async () => {
  const res: any = await hostRankingList({
    type: 2
  });
  if (res && res.code == 200) {
    hotzb.value = res.data;
  }
}
const getdata = async () => {
  if (isYk.value) {
    getHostRankingList();
    return; // 游客不需要查询关注主播
  }
  // 关注主播
  const res: any = await encryptionShowFocusHost();
  if (res && res.code == 200) {
    if (res.data && res.data.length > 0) {
      data.value = res.data;
      hotzb.value = []
    } else {
      getHostRankingList()
    }
  }
};
function formatNum(num) {
  if (num > 100000000) {
    return (num / 100000000).toFixed(0) + "亿";
  } else if (num > 10000) {
    if (num > 1000000) {
      return (num / 10000).toFixed(0) + "万";
    } else if (num > 100000) {
      return (num / 10000).toFixed(1) + "万";
    }
  }
  return num;
}

const toLiveRoom = (data) => {
  uitlsToLiveRoom(data, router)
};
const enStart = async (id) => {
  //取消关注这个主播
  const res: any = await encryptionFocusHost({
    host_id: id,
    del: 1
  })
  if (res.code == 200) {
    Toast.success(t('me.quxiaocg'))
    getdata()
  }
}
//去关注
const toStar = async (id: string) => {

  if (isYk.value) {
    return nativeToLogin(router);
  }

  const res: any = await encryptionFocusHost({
    host_id: JSON.stringify([id])
  })
  if (res.code == 200) {
    Toast.success(t('me.gzcg'))
    getdata()
  }
}

const __returned__ = { livezb, zbtype, t, piniaStore, isYk, router, data, route, hotzb, getHostRankingList, getdata, formatNum, toLiveRoom, enStart, toStar, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})